import { Component, OnInit } from '@angular/core';
import { FormBuilder, Validators, FormGroup, AbstractControl } from '@angular/forms';
import { APILoginService } from '../../_services/login/API-login';
import { APIEntityService } from '../../_services/entity/API-entity';
import { $ModalManagerService } from '../../../../_helpers/Modals/ModalManager.service';
import { formatDate } from '@angular/common';
import { Constants } from '../../../../_utils/Constants';
import { $DBManagerService } from '../../../../_helpers/DB/DBManager.service';
import { Router, ActivatedRoute } from '@angular/router';

const today = new Date();    
var time_today = today.getTime();
var refid = "CID_" + time_today;
const entityId = "EID_" + time_today;

let now = new Date();
const currentdat = formatDate(now, 'yyyy-MM-dd', 'en-US', '+0530');

export interface Id {
  value: string;
  viewValue: string;
}

export interface Item {
  value: string;
  viewValue: string;
}

export interface designation {
  value: string;
  viewValue: string;
}

export interface deportment {
  value: string;
  viewValue: string;
}


@Component({
  selector: 'app-tata-entity-registration',
  templateUrl: './tata-entity-registration.component.html',
  styleUrls: ['./tata-entity-registration.component.css']
})
export class TataEntityRegistrationComponent implements OnInit {

  showPeTmRemainingFeilds: boolean = false;
  disableForm: boolean = false;
  fileSizeError1: boolean = false;
  fileSizeError2: boolean = false;
  PO: boolean;
  RS: boolean;
  PM: boolean;
  TA: boolean;


  constructor(private fb: FormBuilder,
    private es: APILoginService,
    private ls: APIEntityService,
    private $modal: $ModalManagerService,
    private db: $DBManagerService,
    private _route: ActivatedRoute,
    private router: Router) {
    this._route.params.subscribe((params) => {
    this.selectedValue = params['role'];
    })
    this._route.params.subscribe((params) => {
      this.selectedValue = params['item'];
    })
  }

  // For Principal Entity
  entityForm: FormGroup;
  pePrefix: string = "";
  identifiedVal: string = "";
  rootVal: string = "";  
  public Ttsl_ID_Existing = 'N';

  tataRole: any;

  // For Tata Employee
  Ttsl_ID: string = "";

  /*  File Upload */
  uploadKYC: string[];

  selectedValue: String;

  //Dropdown button
  roleCategory: string;
  regProcess = {
    "Process Owner": 2,
    'Registrar': 3,    
    'TTL Agent': 5, 
    'Preference Manager': 6
  }
// Dropdown for Role category
  itemList: Item[] = [
    { value: '2', viewValue: 'Process Owner' },
    { value: '3', viewValue: 'Registrar' },
    { value: '5', viewValue: 'TTL Agent' }, 
    { value: '6', viewValue: 'Preference Manager' } 
  ];

  //Dropdown for designation 
  designations: designation[] = [
    { value: 'SE', viewValue: 'Senior Manager' },
    { value: 'AM', viewValue: 'Assistant Manager' },
    { value: 'DM', viewValue: 'Deputy Manager' },
    { value: 'M', viewValue: 'Manager' },
    { value: 'TL', viewValue: 'Team Lead' },
    { value: 'A', viewValue: 'Associate' },

  ];

//Dropdown for deportments

  deportments: deportment[] = [
    { value: 'RM', viewValue: 'RCM-CC' },
    { value: 'CC', viewValue: 'CSO-SA' },
  ];

  communicationPerf: any;

  public userroles = [];
  public assignedRoles = [];
  public ProcessOwnerRole: any;
  public EntityType: any;
  public PEIdentity: any;
  public data: any;

  entCheck;
  submitted: boolean = false;
  submitted1: boolean = false;

  warningForNotMatchingEnitity: boolean = false;
  makeRead: boolean = false;
  public Ttsl_UserName;
  public entityPresentFlag: boolean = true;
  public existEntityFlag: boolean = false;
  photoName: any;

  photoContent: any;     
  fileExtension: any;
  fileExtensionError: boolean = false;
  fileExtensionMessage: any;
  regrole: any;
  get f() { return this.entityForm.controls; }

  myfiles: any[] = []; 
  grouplist: any =[];
  ranvalue:any;

  ngOnInit() {

    this.entityForm = this.fb.group({ 
      Ttsl_Class: ['',],
      //Ttsl_ID: ['',],
      // Ttsl_ID: ['',[Validators.required,Validators.maxLength(50),Validators.pattern(/^[[A-Za-z0-9._-]*$/)]],
      Ttsl_ID: ['',[Validators.required,Validators.maxLength(20),Validators.pattern(/^[a-zA-Z0-9._-]+$/)]],

      Ttsl_UserName: ['', [Validators.required, Validators.maxLength(50), Validators.pattern('^[a-zA-Z ]*$')]],
     // Ttsl_EmailID: ['', [Validators.required, Validators.pattern(/^([A-Za-z0-9._] +@[A-Za-z0-9\.\-]+\.[A-Za-z]{2,3})*$/)]],   
     // Ttsl_EmailID: ['', [Validators.required, Validators.pattern(/^([A-Za-z0-9._]+\@(tata.com|tatatel.co.in|TATA.COM|TATATEL.CO.IN|Tata.Com|Tata.com|Tatatel.Co.in|Tatatel.co.in)*$)/)]],                                                        
    Ttsl_EmailID: ['', [Validators.required, Validators.pattern(/^([A-Za-z][A-Za-z0-9._-]+\@(tatatel.co.in|tatadocomo.ttsl.com|tatacommunications.com|techmahindra.com)*$)/)]],
   // Ttsl_EmailID: ['', [Validators.required]],  
     Ttsl_MobileNo: ['', [Validators.required, Validators.pattern('^[6-9][0-9]{9}$')]],           
      Ttsl_Designation: ['',],
      Ttsl_Department: ['',],
      Ttsl_RoleCategory: ['',],
      Ttsl_ProcessRole: ['',],
      Ttsl_RegistrarRole: ['',],
      Ttsl_ManagerRole: ['',],
      Ttsl_AgentRole:['',],
      uploadKYC: ['',],
      existEntity_ID: ['',],
      Hash_KYC_Doc: ['',],
      Ttsl_ID_Existing: ['',],  
    });
    //this.createTtslID()
  } 

  async onChangePattern(selectedValue) {
    console.log("selectedValue : ",selectedValue)
    var assignedRoles1;
    await this.ls.getProcessRoles(selectedValue)
      .subscribe(r => {
        assignedRoles1 = r;
      });   
    this.entityForm.controls['existEntity_ID'].reset();
    this.entityForm.controls['Entity_ID'].updateValueAndValidity();
    return assignedRoles1;
  }

async createTtslID(){
  const currentDate = new Date();
  this.ranvalue = "TTSL-"+currentDate.getTime(); 
  this.entityForm.controls['Ttsl_ID'].setValue(this.ranvalue); 
}

  async onRoleChange(item) {
    this.PO = false
    this.RS = false
    this.PM = false
    this.TA = false
    this.entityForm.controls['Ttsl_ProcessRole'].setValidators([]);  
    this.entityForm.controls['Ttsl_RegistrarRole'].setValidators([]);  
    this.entityForm.controls['Ttsl_AgentRole'].setValidators([]);  
    this.entityForm.controls['Ttsl_ManagerRole'].setValidators([]);  

    await this.ls.getProcessRoles(this.regProcess[item])
      .subscribe(r => {
        this.userroles = r["_Reg"];
        console.log("this.userroles -------- " , this.userroles)
      });
      this.userroles.forEach(obj=>{
        this.regrole = this.userroles.filter(opt => opt.allowed).map(opt => opt.rid)
      });         
      this.userroles = this.userroles.filter(function(item, pos, self) {
        return self.indexOf(item) == pos;
    })
    console.log('unic',this.userroles);
    if (item === "Process Owner") {
      this.entityForm.controls['Ttsl_ProcessRole'].enable();
      this.entityForm.controls['Ttsl_ProcessRole'].setValidators([Validators.required]);  
      this.entityForm.controls['Ttsl_ProcessRole'].updateValueAndValidity();
      this.PO = true
      this.entityForm.controls['Ttsl_RegistrarRole'].setValue(null)
     this.entityForm.controls['Ttsl_ManagerRole'].setValue(null);  
     this.entityForm.controls['Ttsl_AgentRole'].setValue(null);  


    this.entityForm.controls['uploadKYC'].clearValidators();
    this.entityForm.controls['uploadKYC'].setValidators([Validators.required]);
    this.entityForm.controls['uploadKYC'].updateValueAndValidity();
    } else if (item === "Registrar") {
      this.entityForm.controls['Ttsl_ProcessRole'].setValue(null);
      this.entityForm.controls['Ttsl_ManagerRole'].setValue(null); 
      this.entityForm.controls['Ttsl_AgentRole'].setValue(null);  
      this.PO = false;

      this.entityForm.controls['Ttsl_RegistrarRole'].enable();
      this.entityForm.controls['Ttsl_RegistrarRole'].setValidators([Validators.required]);
      this.entityForm.controls['Ttsl_RegistrarRole'].updateValueAndValidity();
      this.RS = true  
      
      this.entityForm.controls['uploadKYC'].clearValidators();
      this.entityForm.controls['uploadKYC'].setValidators([Validators.nullValidator]);
      this.entityForm.controls['uploadKYC'].updateValueAndValidity();
      

    }
    else if (item === "TTL Agent") {
      this.entityForm.controls['Ttsl_ProcessRole'].setValue(null);
      this.entityForm.controls['Ttsl_RegistrarRole'].setValue(null);
      this.entityForm.controls['Ttsl_ManagerRole'].setValue(null);   
      this.PO = false;

      this.entityForm.controls['Ttsl_AgentRole'].enable();
      this.entityForm.controls['Ttsl_AgentRole'].setValidators([Validators.required]);
      this.entityForm.controls['Ttsl_AgentRole'].updateValueAndValidity();   
      this.TA = true

      this.entityForm.controls['uploadKYC'].clearValidators();
      this.entityForm.controls['uploadKYC'].setValidators([Validators.nullValidator]);
      this.entityForm.controls['uploadKYC'].updateValueAndValidity();
    }
    else if (item === "Preference Manager") {
      this.entityForm.controls['Ttsl_ProcessRole'].setValue(null);
      this.entityForm.controls['Ttsl_RegistrarRole'].setValue(null); 
      this.entityForm.controls['Ttsl_AgentRole'].setValue(null);  
      this.PO = false;

      this.entityForm.controls['Ttsl_ManagerRole'].enable();
      this.entityForm.controls['Ttsl_ManagerRole'].setValidators([Validators.required]);
      this.entityForm.controls['Ttsl_ManagerRole'].updateValueAndValidity();   
      this.PM = true

      this.entityForm.controls['uploadKYC'].clearValidators();
      this.entityForm.controls['uploadKYC'].setValidators([Validators.nullValidator]);
      this.entityForm.controls['uploadKYC'].updateValueAndValidity();
    }
  }
  isSpecCheckadres:boolean=false;
  noWhitespaceValidator(control) {
 if (control.value.startsWith(' ')) {
   this.isSpecCheckadres=true;
   }else
   if (control.value.endsWith(' ')) {
     this.isSpecCheckadres=true;
   }else{
   this.isSpecCheckadres=false;

   }
 
 
}
  valuechange(checkEntityId, checkPan) {
    let data = {
      "Entity_ID": checkEntityId,
      "Ttsl_Class": this.selectedValue
    }

    this.ls.fetchEntityDetails(data)
      .subscribe(r => {
        this.entityPresentFlag = true;
        if (r.message == "Entity ID not present") {
          this.entityPresentFlag = false;
          this.$modal.errorModal({
            title: 'Registration',
            msg: 'Entity ID not present'
          });
        }
        else if (r.message == "Data Present") {
          this.showPeTmRemainingFeilds = true;
          this.entityPresentFlag = true;
        }
        try {
          if (r.message === 'Data Present') {
            this.existEntityFlag = true;
            this.makeRead = true;
          }
        }
        catch (e) {
          this.warningForNotMatchingEnitity = true;  
        }  
      })
  }

  fileEvent(event): any {
    var file = event.target.files[0];
    this.photoName = file.name;

    var allowedExtensions =
      ["jpg", "jpeg", "png", "JPG", "JPEG", "JFIF", "BMP", "SVG"];
    this.fileExtension = this.photoName.split('.').pop();
console.log("checking : ",this.isInArray(allowedExtensions, this.fileExtension))
    if (this.isInArray(allowedExtensions, this.fileExtension)) {
      alert("Invalid File 1 formate");  
      this.fileExtensionError = false;
      this.fileExtensionMessage = ""
     
    } else {
      this.fileExtensionMessage = "Only photos allowed!!"
      alert("Invalid File 2 formate");
      this.fileExtensionError = true;
    }

    if (file) {
      var reader = new FileReader();
      reader.onloadend = (e: any) => {
        var contents = e.target.result;
        this.photoContent = contents;
      }
      reader.readAsDataURL(file);
    } else {
      alert("Failed to load file");
    }
  }

  /*- checks if word exists in array -*/
  isInArray(array, word) {
    return array.indexOf(word.toLowerCase()) > -1;
  }

  entityidAndPan(alreadyHaveEntity, alreadyHavePan) {
    this.valuechange(alreadyHaveEntity, alreadyHavePan)
  }

  onChangeFileUpload(event) {
console.log("calling onChangeFileUpload")
this.PO=false;
    // this.myfiles = event.target.files;
    var file = event.target.files[0];
    this.photoName = file.name;
    console.log("the size is : ", file.size)
    if (file.size > 4242880) {
      console.log("The size is more ")
      this.fileSizeError1=true;
    }
    else{
      this.fileSizeError1=false;
    }
  if (file.size <= 0) {
      console.log("The size is less ")
      this.fileSizeError2=true;
    }
    else{
      this.fileSizeError2=false;
    }
    var allowedExtensions =
      ["jpg", "jpeg", "png", "JPG", "JPEG", "JFIF", "BMP", "SVG", "pdf","PNG"];
    this.fileExtension = this.photoName.split('.').pop();
    console.log("this.photoName  :  ----------- ",this.photoName)  

    if (this.isInArray(allowedExtensions, this.fileExtension)) {
      this.fileExtensionError = false;
      this.fileExtensionMessage = ""
      this.myfiles = event.target.files;
    } else {
      this.fileExtensionMessage = "Only photos allowed!!"
      this.fileExtensionError = true;
    }

    if (file) {
      var reader = new FileReader();
      reader.onloadend = (e: any) => {
        var contents = e.target.result;
        this.photoContent = contents;
      }
      reader.readAsDataURL(file);
    } else {
      alert("Failed to load file");
    }
    console.log("this is file extension error ....", this.fileExtensionError);
  }


  onChangeRootVal() {
    this.rootVal = this.pePrefix + this.identifiedVal;
  }

  onSubmit() {
    this.submitted1=true
    console.log("CAlling submit")
    console.log("this.entityForm : ",this.entityForm)
    if (this.entityForm.invalid) {
      console.log("this.entityForm.invalid ")
      this.disableForm = true;
      let invalid = [];
      let controls = this.entityForm.controls;
      for (const name in controls) {
        if (controls[name].invalid) {
          invalid.push(name);
          console.log(invalid);
        }
      }
      return;
    }
    else if(this.fileExtensionError || this.fileSizeError2 ||this.fileSizeError1){
      return;
    }
    if (this.entCheck === 'No') {
      console.log("this.entCheck === No ")
      this.Ttsl_ID_Existing = 'N';
      this.Ttsl_ID = this.entityForm.get("Ttsl_ID").value;
      this.EntityRegistartion(this.Ttsl_ID_Existing);
    }

    else {
      console.log("inside else")
      this.onChangeRootVal();
      this.Ttsl_ID_Existing = 'Y';
      this.submitted = true;
      if (this.entityForm.invalid) {
        return;
      }
      else {
        console.log("inside else last")
        this.EntityRegistartion(this.Ttsl_ID_Existing);
      }
    } 
  }
  omit_special_char(e) {
    var k;
    document.all ? k = e.keyCode : k = e.which;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
}

  resetKYC() {             
    console.log(this.entityForm.controls['uploadKYC'].value);  
    this.entityForm.controls['uploadKYC'].reset();
    console.log(this.entityForm.controls['uploadKYC'].value);

    this.entityForm.controls['uploadKYC'].clearValidators();
    this.entityForm.controls['uploadKYC'].setValidators([Validators.required]);
    this.entityForm.controls['uploadKYC'].updateValueAndValidity();
    this.myfiles = [];
    this.PO=true;
  }

  EntityRegistartion(Ttsl_ID_Existing) {
    console.log("Calling Entity Registration ...")
    if(this.PO){
      this.PO=true;
      return
    }
    let Ttsl_ID = this.entityForm.get("Ttsl_ID").value; 
    let Ttsl_UserName = this.entityForm.get("Ttsl_UserName").value; 
    let Ttsl_EmailID = this.entityForm.get("Ttsl_EmailID").value;
    let Ttsl_MobileNo = this.entityForm.get("Ttsl_MobileNo").value;
    let Ttsl_Designation = this.entityForm.get("Ttsl_Designation").value;
    let Ttsl_Department = this.entityForm.get("Ttsl_Department").value;
    let Ttsl_RoleCategory = this.entityForm.get("Ttsl_RoleCategory").value;
    let Ttsl_ProcessRole = this.entityForm.get("Ttsl_ProcessRole").value;
    let Ttsl_RegistrarRole = this.entityForm.get("Ttsl_RegistrarRole").value;
    let Ttsl_ManagerRole =this.entityForm.get("Ttsl_ManagerRole").value;
    let Registrar_Status = this.entityForm.get("Ttsl_RegistrarRole").value;
    let Ttsl_AgentRole = this.entityForm.get("Ttsl_AgentRole").value;

    console.log(" Ttsl_AgentRole ----------------  ", Ttsl_AgentRole)       

    Ttsl_EmailID = Ttsl_EmailID.toLowerCase()
    const entityForm: FormData = new FormData();
    entityForm.append('Ttsl_ID', Ttsl_ID);  
    entityForm.append('Ttsl_UserName', Ttsl_UserName);
    entityForm.append('Ttsl_EmailID', Ttsl_EmailID);
    entityForm.append('Ttsl_MobileNo', Ttsl_MobileNo);
    entityForm.append('Ttsl_Department', Ttsl_Department);
    entityForm.append('Ttsl_Designation', Ttsl_Designation);
    entityForm.append('Ttsl_RoleCategory', Ttsl_RoleCategory);
    entityForm.append('Ttsl_ProcessRole', Ttsl_ProcessRole);
    entityForm.append('Ttsl_RegistrarRole', Ttsl_RegistrarRole);
    entityForm.append('Ttsl_ManagerRole', Ttsl_ManagerRole);
    entityForm.append('Ttsl_AgentRole', Ttsl_AgentRole);
    entityForm.append('Registrar_Status', Registrar_Status);  
    const file1: any = document.getElementById('uploadKYC');     
	 for(var i=0;i<=this.myfiles.length;i++)   
	 { 
		 entityForm.append('file'[i], this.myfiles[i]);		  
	 } 
    entityForm.append('Ttsl_ID_Existing', Ttsl_ID_Existing);  
    entityForm.append('Create_Date', currentdat);
    entityForm.append('Ttsl_Class', "Tata Employee");
    this.es.tataentityRegistration(entityForm)      
      .subscribe(r => {
        console.log("r : ",r)  
        console.log("r.insertInMongo : ",r.insertInMongo)
        try {
          if (r.validation_1) {
            this.$modal.errorModal({
              title: 'Registration',
              msg: 'TTSL ID already exists!' 
            });
          }
          else if (r.message == "Ttsl ID already exists") {
            this.$modal.errorModal({
              title: 'Registration',
              msg: 'Ttsl ID already exists!' 
            });
          } else if (r.message == "Email ID already registered") {
            this.$modal.errorModal({
              title: 'Registration',
              msg: 'Email ID already registered!' 
            }); 
          } else if (r.message == "Mobile Number already registered") {
            this.$modal.errorModal({
              title: 'Registration',
              msg: 'Mobile Number already registered!' 
            }); 
          }  else if (r.message == 'Email ID & Mobile Number already registered') {
            this.$modal.errorModal({
              title: 'Registration',
              msg: "Email ID & Mobile Number already registered" 
            }); 
          }       
          
          else if (r.insertInMongo != undefined) {
            if (r.insertInMongo.Ttsl_Status == "C") {    
              this.db.set(Constants.SESSSION_STORAGE, Constants.TTSL_REF_NO, r.insertInMongo.Ttsl_Ref_No);
              this.db.set(Constants.SESSSION_STORAGE, Constants.ENTITY_ID, r.insertInMongo.Ttsl_ID);
              this.$modal.successModal({
                title: 'TTSL Registration',  
                msg: 'Your request for new Tata Employee is registered with us and is pending for approval. We shall revert to you in 48 hours. ' + ' Your Id ' + r.insertInMongo.Ttsl_Ref_No
              });
              var data = {
                  "Ttsl_Class": "Tata Employee",
                  "Ttsl_ID": r.insertInMongo.Ttsl_ID,
                  "Ttsl_UserName": r.insertInMongo.Ttsl_UserName,
                  "Ttsl_EmailID": r.insertInMongo.Ttsl_EmailID,
                  "Ttsl_MobileNo": r.insertInMongo.Ttsl_MobileNo,
                  "Ttsl_Designation": r.insertInMongo.Ttsl_Designation,
                  "Ttsl_Department": r.insertInMongo.Ttsl_Department,
                  "Ttsl_RoleCategory": r.insertInMongo.Ttsl_RoleCategory,
                  "Ttsl_ProcessRole": r.insertInMongo.Ttsl_ProcessRole,
                  "Ttsl_RegistrarRole": r.insertInMongo.Ttsl_RegistrarRole,    
                  "Ttsl_ManagerRole": r.insertInMongo.Ttsl_ManagerRole,
                  "Ttsl_AgentRole": r.insertInMongo.Ttsl_AgentRole,
                  "notificationDate": currentdat,
                  "Ttsl_Ref_No": r.insertInMongo.Ttsl_Ref_No,   
                  "entity_username": r.insertInMongo.Ttsl_EmailID,
                  "notificationType": "EntityRegistration" 
              }
              this.router.navigateByUrl('/')

            } 
          }
        }
        catch (e) {
          console.log("catch in registration", e); 
        }
      });
  }
}
export function noWhiteSpace(control: AbstractControl) {
  var data = control.value;
  if (data == " " || data.charAt(0) === " " || data.charAt(data.length - 1) === " ") {
    return { validUrl: true };
  }
  return null;
}
